// Import and initialize Datadog RUM
import { datadogRum } from '@datadog/browser-rum';

// Only initialize Datadog RUM in non-development environments
const env = import.meta.env.VITE_APP_ENV || 'development';
if (env !== 'development') {
  datadogRum.init({
    applicationId: '7db16c50-d157-403d-b4f6-219baced2ee5',
    clientToken: 'pub9e351f2ed96516972cac80b01a893c46',
    site: 'datadoghq.com',
    service: 'anzir-offical-site',
    env: env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'allow',
  });
}

// Import i18n before React and other libraries
import './i18n';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
